var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTransferSearch = function SvgTransferSearch(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4249 1.68848C5.35776 1.68848 1.25 5.79624 1.25 10.8634C1.25 15.9306 5.35776 20.0384 10.4249 20.0384C12.73 20.0384 14.8365 19.1883 16.4481 17.7847L21.4636 22.9634C21.7517 23.261 22.2266 23.2686 22.5241 22.9804C22.8216 22.6922 22.8293 22.2174 22.5411 21.9199L17.4958 16.7104C18.81 15.1228 19.5999 13.0854 19.5999 10.8634C19.5999 5.79624 15.4921 1.68848 10.4249 1.68848ZM2.75 10.8634C2.75 6.62466 6.18619 3.18848 10.4249 3.18848C14.6637 3.18848 18.0999 6.62466 18.0999 10.8634C18.0999 15.1022 14.6637 18.5384 10.4249 18.5384C6.18619 18.5384 2.75 15.1022 2.75 10.8634Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTransferSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "transfer-search.cff9dc4f694869d4e195d4c40f70277a.svg";